import { BigNames } from './BigNames';

export default BigNames;
